/**
 * @generated SignedSource<<be4d3591897923f367b6afe192f85504>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HydrantFamilyInputHydrantFamiliesQuery$variables = {};
export type HydrantFamilyInputHydrantFamiliesQueryVariables = HydrantFamilyInputHydrantFamiliesQuery$variables;
export type HydrantFamilyInputHydrantFamiliesQuery$data = {
  readonly hydrantFamilies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly manufacturer: {
          readonly id: string;
        };
      };
    }>;
  };
};
export type HydrantFamilyInputHydrantFamiliesQueryResponse = HydrantFamilyInputHydrantFamiliesQuery$data;
export type HydrantFamilyInputHydrantFamiliesQuery = {
  variables: HydrantFamilyInputHydrantFamiliesQueryVariables;
  response: HydrantFamilyInputHydrantFamiliesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HydrantFamilyInputHydrantFamiliesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantFamilyConnection",
        "kind": "LinkedField",
        "name": "hydrantFamilies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HydrantFamilyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HydrantFamily",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "manufacturer",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HydrantFamilyInputHydrantFamiliesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantFamilyConnection",
        "kind": "LinkedField",
        "name": "hydrantFamilies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HydrantFamilyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HydrantFamily",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "manufacturer",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ee5ffd534afd7fc9b83003577fd35630",
    "id": null,
    "metadata": {},
    "name": "HydrantFamilyInputHydrantFamiliesQuery",
    "operationKind": "query",
    "text": "query HydrantFamilyInputHydrantFamiliesQuery {\n  hydrantFamilies {\n    edges {\n      node {\n        id\n        name\n        manufacturer {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9da09de0192e83ccc54e49f2f3c0b7fd";

export default node;
